import { ServerExportStatusBanner } from 'components/server-export-status-banner';

import type { MapQueryExport } from './use-map-query-export';

// The page's CSV export status, on the dataset tab line so it never takes height
// from a results table. Names the dataset: any tab may be open by then.
export const MapQueryExportBanner = ({
  mapQueryExport: { exportStatus, resetExport, exportLabel },
  className,
}: {
  mapQueryExport: MapQueryExport;
  className?: string;
}) => {
  if (exportStatus.status === 'idle') return null;

  return (
    <div className={className}>
      <ServerExportStatusBanner
        status={exportStatus}
        onDismiss={resetExport}
        processingTitle={`Exporting ${exportLabel}…`}
        processingSubtitle="Downloads automatically when ready."
        successTitle={`${exportLabel} export ready`}
        failureTitle={`Couldn't export ${exportLabel}.`}
      />
    </div>
  );
};
